require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bons-plans-1-10.json") })
        }
      }, "path---bons-plans-1-10");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bons-plans-1-10!./.cache/json/bons-plans-1-10.json
// module id = 351
// module chunks = 231608221292675